export class Validator {
  errors = {}

  checkValidation (translate, form, validationObjects) {
    for (let it in validationObjects) {
      for (let val in validationObjects[it].validations) {
        if (validationObjects[it].validations[val] === 'required' && (!form[validationObjects[it].input] || form[validationObjects[it].input] === null)) {
          if (!this.errors[validationObjects[it].error]) {
            this.errors[validationObjects[it].error] = []
          }
          this.errors[validationObjects[it].error].push(translate.t(validationObjects[it].name + ' megadása kötelező!'))
        }
        if (validationObjects[it].validations[val] === 'numeric' && isNaN(form[validationObjects[it].input])) {
          if (!this.errors[validationObjects[it].error]) {
            this.errors[validationObjects[it].error] = []
          }
          this.errors[validationObjects[it].error].push(translate.t(validationObjects[it].name + ' csak szám lehet!'))
        }
      }
    }

    return this.errors
  }
}



// WEBPACK FOOTER //
// ./src/assets/services/validator.js